<footer class="footer">
  <div class="container-fluid">
    <span class="pull-left"> Xin chào: {{userFullname}}
    </span>
    <div class="copyright ml-auto">
      {{'project.name' | translate}}
    </div>
  </div>
</footer>